import React from "react";
import { evaluatePassword } from "../../lib/passwordStrength";

export default function PasswordStrengthChecker({ password }) {
  const result = evaluatePassword(password);

  return (
    <div className={`password-strength${result.tone ? ` is-${result.tone}` : ""}`} aria-live="polite">
      <div className="password-strength__meter" aria-hidden="true">
        {[0, 1, 2, 3].map((index) => (
          <span
            key={index}
            className={`password-strength__bar${index < result.meter ? " is-filled" : ""}`}
          />
        ))}
      </div>
      <div className="password-strength__label">
        {result.label ? `Password strength: ${result.label}` : "Password strength"}
      </div>
      <ul className="password-strength__checks">
        {result.checks.map((check) => (
          <li key={check.id} className={check.passed ? "is-passed" : ""}>
            {check.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
